module.exports = __webpack_public_path__ + "static/media/vote-icon.9fc6979e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vote-icon.svg
// module id = 452
// module chunks = 1